import { FilterBuilder } from '@/shared/filters/filter-builder';
import { JobLogsFilterInput } from '@/shared/types/types.generated';

export class JobLogsFilter extends FilterBuilder<
  JobLogsFilterInput,
  JobLogsFilter
> {
  public allowedFilters: Array<keyof JobLogsFilterInput> = ['nextToken'];
}
